import { useContext } from 'react';
import { GeneralContext } from '@frodo/lib/providers/GeneralProvider';

export const useCampaign = (key: string) => {
  const context = useContext(GeneralContext);

  if (!context) {
    throw new Error('useCampaign must be used within GeneralProvider');
  }

  return context.campaigns?.[key];
};
